<template>
  <div>
    <v-card>
      <v-card-title class="text-h5">
        Edicion de horarios
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          Edita los precios y duraciones del horario seleccionado, los cambios
          no seran aplicados hasta el guardado de la información
          <h2>Dia:{{ $pgsHelper.getDayName(dataEdit.dia) }}</h2>
          <h2 class="mt->4">Hora:{{ dataEdit.horario }}</h2>
          <v-text-field
            class="mb-n4"
            label="Jugadores Maximos"
            prepend-icon="mdi-clock-outline"
            :rules="rules.requerido"
            v-mask="'####'"
            v-model="mpl"
            outlined
            dense
            required
          ></v-text-field>
          <v-row>
            <v-col md="8" cols="12">
              <v-autocomplete
                v-model="seletedByToAdd"
                label="Seleccione una bahia para agregar"
                :items="bahias"
                item-text="nm"
                item-value="id"
              >
              </v-autocomplete>
            </v-col>
            <v-col md="4" cols="12"
              ><v-btn
                small
                color="primary"
                class="mt-4"
                @click="addBahiaToTime()"
              >
                Agregar Bahia
              </v-btn>
            </v-col>
          </v-row>
          <v-expansion-panels class="mt-2">
            <v-expansion-panel
              v-for="(bahia, indexBahia) in dataEdit.duraciones"
              :key="indexBahia"
            >
              <v-expansion-panel-header>
                {{ bahia.BahiaName }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col md="6" cols="12">
                    <v-text-field
                      class="mb-n4"
                      label="Agregar Duracion (min)"
                      prepend-icon="mdi-clock-outline"
                      v-mask="'###'"
                      v-model="duracionAdd"
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col md="6" cols="12">
                    <a
                      style="position:absolute; right:30px;"
                      width="50"
                      color="red"
                      @click="deleteBahiaTotime(indexBahia)"
                    >
                      Eliminar Bahia
                    </a>
                    <v-btn
                      @click="addDuracionToBahia(bahia.Bahia, indexBahia)"
                      color="primary"
                      >Agregar Duracion</v-btn
                    >
                  </v-col>
                </v-row>
                <!-- Segundo expansion panel -->

                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(duracion, indexDuracion) in bahia.Duraciones"
                    :key="indexDuracion + ' ' + indexBahia"
                  >
                    <v-expansion-panel-header>
                      <h3 class="mb-0">{{ duracion.Duracion }} min.</h3>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col class="mt-n3" cols="12" md="6">
                          <v-autocomplete
                            v-model="dataToAdd.ct.id"
                            dense
                            :items="Categories"
                            item-text="Nombre"
                            item-value="id"
                            label="Categoria"
                          ></v-autocomplete>
                        </v-col>
                        <v-col class="mt-n3" cols="12" md="6">
                          <v-text-field
                            v-model="dataToAdd.pc.C"
                            label="Precio"
                            dense
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col class="mt-n3" cols="12" md="6">
                          <v-autocomplete
                            v-model="dataToAdd.pc.M"
                            :items="monedas"
                            item-text="Nombre"
                            item-value="id"
                            dense
                            label="Moneda"
                          ></v-autocomplete>
                        </v-col>
                        <v-col class="mt-n3" cols="12" md="6">
                          <v-btn
                            @click="
                              addPriceToDuracion(indexBahia, indexDuracion)
                            "
                            small
                            color="primary"
                            >+</v-btn
                          >
                        </v-col>
                      </v-row>
                      <v-list dense>
                        <v-list-item
                          v-for="(precio,
                          indexPrecio) in duracion.BahiasPrecios"
                          :key="indexPrecio + ' ' + indexDuracion"
                        >
                          <v-row>
                            <v-col md="4" cols="12">
                              <h4 class="mt-4">
                                {{ precio.ct.nm }}
                              </h4>
                            </v-col>
                            <v-col md="4" cols="12">
                              <v-text-field
                                v-model="precio.pc.C"
                                label="Precio"
                              ></v-text-field>
                            </v-col>
                            <v-col md="4" cols="12">
                              <v-btn
                                @click="
                                  deletePrice(
                                    indexBahia,
                                    indexDuracion,
                                    indexPrecio
                                  )
                                "
                                small
                                class="mt-4"
                                color="red"
                                dark
                                ><v-icon>mdi mdi-delete</v-icon></v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-list-item>
                      </v-list>
                      <a
                        style="position:absolute; right:30px; bottom: 12px;"
                        width="50"
                        color="red"
                        @click="
                          deleteDuracionToBahia(indexBahia, indexDuracion)
                        "
                      >
                        Eliminar duracion
                      </a>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- Segundo expansion panel end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" @click="cancel()" text>
          Cancelar
        </v-btn>
        <v-btn @click="applyChanges()" color="green darken-1" text>
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "EditorTimes",
  components: {},
  props: {
    dataEdit: Object,
    activity: String,
    actividades: Array,
    bahias: Array,
    familias: Array,
  },
  data() {
    return {
      rules: {
        requerido: [(value) => !!value || "El campo es obligatorio"],
      },
      Categories: [],
      seletedByToAdd: null,
      duracionAdd: 60,
      mpl: 0,
      dataToAdd: {
        fmi: "",
        fmn: "",
        ct: { id: "", nm: "" },
        pc: { C: 0, M: "MXN" },
      },
    };
  },
  methods: {
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    getMaxPlayers() {
      
      this.dataEdit.duraciones.forEach((dur) => {
        dur.Duraciones.forEach((dura) => {
          dura.BahiasPrecios.forEach((bp) => {
            this.mpl = bp.mpl;
          });
        });
      });
    },
    cancel() {
      this.$emit("cancel");
    },
    applyChanges() {
      if (this.$refs.form.validate()) {
        let dataEmit = this.$pgsHelper.cloneObj(this.dataEdit);
        dataEmit.duraciones.forEach((bahias) => {
          bahias.Duraciones.forEach((duracion) => {
            duracion.BahiasPrecios.forEach((precio) => {
              precio.pc.C = Number(precio.pc.C);
              precio.mpl = Number(this.mpl);
            });
          });
        });
        //this.dataToAdd.pc.C = Number(this.dataToAdd.pc.C)
        this.$emit("applyChange", dataEmit);
      }
    },
    addBahiaToTime() {
      let existBahia = this.$pgsHelper.getById(
        this.dataEdit.duraciones,
        "Bahia",
        this.seletedByToAdd
      );
      if (!existBahia) {
        let bahiaName = "";
        let bahiaExist = this.$pgsHelper.getById(
          this.bahias,
          "id",
          this.seletedByToAdd
        );
        if (bahiaExist) {
          bahiaName = bahiaExist.nm;
        }
        this.dataEdit.duraciones.push({
          Bahia: this.seletedByToAdd,
          BahiaName: bahiaName,
          Duraciones: [],
        });
      } else {
        this.$toast.error(" ", "La bahia ya existe en este horario");
      }
    },
    deleteBahiaTotime(index) {
      this.dataEdit.duraciones.splice(index, 1);
    },
    addDuracionToBahia(bahia, indexBahia) {
      let existDurationInBahia = this.$pgsHelper.getById(
        this.dataEdit.duraciones[indexBahia].Duraciones,
        "Duracion",
        this.duracionAdd
      );
      if (!existDurationInBahia) {
        this.dataEdit.duraciones[indexBahia].Duraciones.push({
          Duracion: this.duracionAdd,
          BahiasPrecios: [],
        });
      } else {
        this.$toast.error(" ", "La duracion ya existe en esta bahia");
      }
    },
    deleteDuracionToBahia(indexBahia, indexDuracion) {
      this.dataEdit.duraciones[indexBahia].Duraciones.splice(indexDuracion, 1);
    },
    deletePrice(indexBahia, indexDuracion, indexPrecio) {
      this.dataEdit.duraciones[indexBahia].Duraciones[
        indexDuracion
      ].BahiasPrecios.splice(indexPrecio, 1);
    },
    addPriceToDuracion(indexBahia, indexDuracion) {
      let exist = false;
      let indexExist = 0;
      this.dataEdit.duraciones[indexBahia].Duraciones[
        indexDuracion
      ].BahiasPrecios.forEach((pre, index) => {
        if (pre.ct.id == this.dataToAdd.ct.id) {
          exist = true;
          indexExist = index;
        }
      });
      if (exist) {
        this.$toast.error(" ", "Ya existe un precio para esta categoría");
      } else {
        this.dataToAdd.fmi = this.getCategoriaById(
          this.dataToAdd.ct.id
        ).Familia;
        this.dataToAdd.fmn = this.getFamiliasById(
          this.getCategoriaById(this.dataToAdd.ct.id)?.Familia
        ).text;
        this.dataToAdd.ct.nm = this.getCategoriaById(
          this.dataToAdd.ct.id
        ).Nombre;
        this.dataToAdd.pc.C = Number(this.dataToAdd.pc.C);
        this.dataEdit.duraciones[indexBahia].Duraciones[
          indexDuracion
        ].BahiasPrecios.push(this.$pgsHelper.cloneObj(this.dataToAdd));
      }
    },
    getFamiliasById(id) {
      let exist = this.$pgsHelper.getById(this.familias, "value", id);
      if (exist) {
        return exist;
      } else {
        return "Categoria no valida";
      }
    },
    getBahiaNameById(id) {
      let exist = this.$pgsHelper.getById(this.bahias, "id", id);
      if (exist) {
        return exist.nm;
      } else {
        return "---";
      }
    },
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params?.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    getCategoriaById(id) {
      let exist = this.$pgsHelper.getById(this.Categories, "id", id);
      if (exist) {
        return exist;
      } else {
        return "Categoria no valida";
      }
    },
    timeMask(value) {
      const hours = [/[0-2]/, value.charAt(0) === "2" ? /[0-3]/ : /[0-9]/];
      const minutes = [/[0-5]/, /[0-9]/];
      return value.length > 2 ? [...hours, ":", ...minutes] : hours;
    },
    timeRangeMask(value) {
      const numbers = value.replace(/[^0-9]/g, "");
      if (numbers.length > 4) {
        return [
          ...this.timeMask(numbers.substring(0, 4)),
          "-",
          ...this.timeMask(numbers.substring(4)),
        ];
      }
      return [...this.timeMask(numbers)];
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    ...mapGetters(["getPDVMonedasLista"]),
    monedas() {
      let monedas = [];
      this.getPDVMonedasLista.forEach((moneda) => {
        monedas.push(moneda);
      });
      return monedas;
    },
  },
  mounted() {
    this.getCategories();
    this.getMaxPlayers();
  },
};
</script>
